<div class="modal-header justify-content-end">
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')" >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="container d-flex justify-content-center mt-2" style="min-height: 30vh;">
    <div class="card card-background points-card-background">
      <h4 class="title mt-2 uppercase">{{providerName}}</h4>
      <div class="d-flex flex-column align-items-center mt-3 w-100">
        @if(barcodeUser){
          <ngx-barcode6 class="barcode"
            bc-format="CODE128"
            [bc-width]="3"
            [bc-height]="75"
            [bc-value]="barcodeUser"
            [bc-display-value]="false"
            >
          </ngx-barcode6>
        }

        <div class="mt-4 text-black text-center">
          {{this._user?.id}}<br>
          {{ bpAgent }}
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="container">
    <div class="text-center p-2">
      {{ "ACCOUNT.BARCODE_INFO" | translate }}
    </div>
  </div> -->
</div>